const setCountDownInfo = function (LocalStorageKey, duration) {
  const time = localStorage.getItem(LocalStorageKey)
  if (time && time !== 0) {
    const timeStamp = parseInt(time)
    const now = Date.now()
    if (now < timeStamp) {
      return timeStamp - now
    } else {
      localStorage.setItem(LocalStorageKey, 0)
      return resetCountDown(LocalStorageKey, duration)
    }
  } else {
    return resetCountDown(LocalStorageKey, duration)
  }
}

function resetCountDown (key, duration) {
  const timeStamp = Date.now() + duration
  localStorage.setItem(key, timeStamp)
  return duration
}

const CountDownTool = {}
const CountDownConstant = {
  HomeCountDownEndTime: 'HOME_PASSCARD_COUNT_DOWN', // 记录首页倒计时的结束时间，该值存在，说明当天本次登录至少已经进行过一次完整的倒计时，首页不再暂时pass卡倒计时
  PassCardCountDownTimeStamp: 'passcardCountDownTime', // 记录pass卡倒计时的结束时间，该值存在且===0时，说明倒计时已结束，在pass卡提现拒绝页需要重新获取倒计时数据
  AndroidNativeCountDownMethod: 'passCardCountDownTime',
  upGuideCountDownTimeStamp: 'upGuideCountDownTimeStamp',
  reviewingGuideUpCountDownTimeStamp: 'reviewingGuideUpCountDownTimeStamp'
}

CountDownTool.setCountDownInfo = setCountDownInfo
CountDownTool.Keys = CountDownConstant

export default CountDownTool